<template>
	<modal
		id="create-substudy-modal"
		title="Create A Substudy"
		cancel-label="Cancel"
		continue-label="Save"
		v-on:confirm="saveNewSubstudy"
		v-on:closed="cancel"
		:showModal="showModal"
	>
		<template v-slot:body>
			<div class="form-group">
				<label for="substudy-name-input">Name:</label>
				<input type="text" v-model="name" class="form-control" id="substudy-name-input" autocomplete="off">
			</div>
			<div class="checkbox">
				<label for="active-checkbox">
					<input type="checkbox" v-model="active" id="active-checkbox">
					Active
				</label>
			</div>
			<div class="checkbox">
				<label for="auto-tasks-checkbox">
					<input type="checkbox" v-model="auto_tasks" :disabled="active==false" id="auto-tasks-checkbox">
					Create tasks on participant creation?
				</label>
			</div>
		</template>
	</modal>
</template>

<script setup>
	import { ref, watch } from 'vue'
	import Modal from '../../Modal.vue'

	const props = defineProps(['showModal'])
	const emit = defineEmits(['confirm', 'closed'])
	const name = ref(null)
	const active = ref(true)
	const auto_tasks = ref(false)

	function saveNewSubstudy() {
		if (name.value && name.value.trim() != '') {
			axios.post('/api/substudies', {name: name.value, active: active.value, auto_tasks: auto_tasks.value})
				.then(function (response) {
					emit('confirm');
          clearForm();
				}.bind(this))
				.catch(function (error) {
					console.error(error);
					alert('there was a problem creating the substudy')
				})
		}
	}

  function cancel() {
		emit('closed');
    clearForm();
	}

  function clearForm() {
    name.value = null
    active.value = true
    auto_tasks.value = false
  }

	watch(active, async (newActive, oldActive) => {
		if (newActive == false) {
			auto_tasks.value = false
		}
	})
</script>